import axios from "axios";
import ThemeMaker from "../../components/thememaker";
import { config } from "../../utils/config";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import jwtDecode from "jwt-decode";

import {
    Form,
    Input,
    Select,
    Row,
    Col,
    Button,
    Upload,
    Avatar,
    Card
} from "antd";
import { UploadOutlined } from "@ant-design/icons";




const UserDetails = () => {
    const { apiEndpoint } = config;
    const [form] = Form.useForm();
    const [userData, setUserData] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const token = sessionStorage.getItem("token");
    let currentSellerId = sessionStorage.getItem("seller_id");
    if (!currentSellerId && token) {
        try {
            const decodedToken = jwtDecode(token);
            currentSellerId = decodedToken?.data?.seller_data?.[0]?.id || decodedToken?.data?.user?.[0]?.seller_id || decodedToken?.seller_id || decodedToken?.data?.seller_id;
        } catch (e) {
            console.error("JWT Decode error:", e);
        }
    }
    const isSellerAdmin = String(userData?.seller_id || currentSellerId) === "1" || userData?.seller_id === 1 || currentSellerId === 1;

    const getApprovalLabel = (status) => {
        return (status === 1 || status === "1") ? "Approved" : "Pending";
    };


    const getUserData = async () => {
        try {
            const token = sessionStorage.getItem("token");
            let sellerId = sessionStorage.getItem("seller_id");
            if (!sellerId && token) {
                try {
                    const decodedToken = jwtDecode(token);
                    sellerId = decodedToken?.data?.seller_data?.[0]?.id || decodedToken?.data?.user?.[0]?.seller_id;
                } catch (e) {
                    console.error("JWT Decode error:", e);
                }
            }

            const response = await axios({
                url: `${apiEndpoint}/snp/sellers/get/${sellerId}`,
                method: "GET",
                headers: {
                    "content-type": "application/json",
                    "X-Custom-Authorization": `Bearer ${token}`
                }
            });

            const sellerObj = Array.isArray(response?.data?.seller)
                ? response.data.seller[0]
                : (response?.data?.seller || response?.data?.data?.seller || response?.data?.data || {});

            const userObj = Array.isArray(response?.data?.user)
                ? response.data.user[0]
                : (response?.data?.user || response?.data?.data?.user || {});

            const kycObj = Array.isArray(response?.data?.kyc)
                ? response.data.kyc[0]
                : (response?.data?.kyc || response?.data?.data?.kyc || {});

            const bankObj = Array.isArray(response?.data?.bank_account)
                ? response.data.bank_account[0]
                : (response?.data?.bank_account || response?.data?.data?.bank_account || {});

            const rawAppStatus = sellerObj.approve_status !== undefined && sellerObj.approve_status !== null
                ? sellerObj.approve_status
                : userObj.approve_status;
            const isApproved = Number(rawAppStatus) === 1 || rawAppStatus === "1" || rawAppStatus === true;
            const appStatus = isApproved ? 1 : 0;
            const appStatusLabel = isApproved ? "Approved" : "Pending";

            const mappedData = {
                company_name: sellerObj.company_name || "",
                contact_no: sellerObj.contact_no || "",
                user_name: userObj.name || "",
                user_email: userObj.email || userObj.display_email || "",
                features_enabled: sellerObj.features_enabled || "N/A",
                user_mobile: userObj.contact_no || sellerObj.contact_no || "",
                seller_type: sellerObj.seller_type ? sellerObj.seller_type.toLowerCase() : "",
                min_order_value: sellerObj.min_order_value || "",
                pan_no: kycObj.pan_no || sellerObj.pan_no || sellerObj.pan_number || "",
                gst_no: kycObj.gst_no || sellerObj.gst_no || sellerObj.gst_number || "",
                short_description: sellerObj.short_description || "",
                seller_source: sellerObj.seller_source || "",
                status: sellerObj.status !== undefined && sellerObj.status !== null ? (sellerObj.status ? "true" : "false") : "",
                approve_status: appStatus,
                approve_status_label: appStatusLabel,
                logo: sellerObj.logo || "",
                pan_image: kycObj.pan_image || sellerObj.pan_image || "",
                gst_image: kycObj.gst_image || sellerObj.gst_image || "",
                description: sellerObj.description || "",
                seller_id: sellerObj.id || sellerObj.seller_id || userObj.seller_id || sellerId
            };

            setUserData(mappedData);
            form.setFieldsValue(mappedData);
        } catch (error) {
            console.log("Get User Data Error:", error);
        }
    };

    const updateUserData = async (values) => {
        try {
            await form.validateFields();
        } catch (err) {
            toast.error("Please fill in all required fields!");
            return;
        }

        setIsLoading(true);
        try {
            const token = sessionStorage.getItem("token");
            let decodedToken = null;
            if (token) {
                try {
                    decodedToken = jwtDecode(token);
                } catch (e) {
                    console.error("JWT Decode error in update:", e);
                }
            }
            const sellerId = decodedToken?.data?.seller_data?.[0]?.id || decodedToken?.data?.user?.[0]?.seller_id || decodedToken?.seller_id || sessionStorage.getItem("seller_id") || userData?.seller_id;

            const payload = {
                ...values,
                pan_no: values.pan_no || values.pan_number || "",
                gst_no: values.gst_no || values.gst_number || "",
                approve_status: userData.approve_status,
            };
            delete payload.pan_number;
            delete payload.gst_number;
            delete payload.approve_status_label;

            const response = await axios({
                url: `${apiEndpoint}/snp/sellers/update/${sellerId}`,
                method: "PUT",
                headers: {
                    "content-type": "application/json",
                    "X-Custom-Authorization": `Bearer ${token}`
                },
                data: payload
            });
            toast.success(response?.data?.message || "Seller updated successfully!");
            getUserData();
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            console.error("Seller update error:", error);
            toast.error(error?.response?.data?.message || "Update Failed");
        }
    };

    const handleCustomUpload = async ({ file, onSuccess, onError }, field) => {
        const allowedExtensions = /\.(png|jpe?g|webp|gif|bmp|img)$/i;
        const isAllowedType = (file?.type && file.type.startsWith("image/")) || allowedExtensions.test(file?.name || "");

        if (!isAllowedType) {
            const errorMsg = "Only PNG and image files are allowed!";
            toast.error(errorMsg);
            if (onError) onError(new Error(errorMsg));
            return;
        }

        try {
            const token = sessionStorage.getItem("token");
            const formData = new FormData();
            formData.append("file", file);

            const response = await axios({
                method: "POST",
                url: `${apiEndpoint}/snp/upload`,
                data: formData,
                headers: {
                    "x-custom-authorization": `Bearer ${token}`,
                }
            });

            const resData = response?.data;
            const url = resData?.urls?.[0] || resData?.url || resData?.data?.urls?.[0] || resData?.data?.url || (typeof resData?.data === "string" ? resData?.data : null);

            if (url) {
                form.setFieldsValue({
                    [field]: url
                });
                setUserData(prev => ({ ...prev, [field]: url }));
                toast.success(`${field.replace("_", " ").toUpperCase()} uploaded successfully!`);
                onSuccess(resData, file);
            } else {
                toast.error(`${field.replace("_", " ").toUpperCase()} upload failed: No URL in response`);
                onError(new Error("No URL in response"));
            }
        } catch (error) {
            console.error("Upload error:", error);
            toast.error(error?.response?.data?.message || error?.message || `${field.replace("_", " ").toUpperCase()} upload failed!`);
            onError(error);
        }
    };

    useEffect(() => {
        getUserData();
    }, []);

    return (
        <ThemeMaker>
            <Card className="card mx-4 my-4" style={{ borderRadius: 12, height: '68vh', overflowX: "scroll", scrollbarWidth: "none" }}>
                <div style={{ display: "flex", alignItems: "center", marginBottom: 20 }}>
                    <Avatar size={80} src={form.getFieldValue("logo")} />
                    <div style={{ marginLeft: 20 }}>
                        <h5 className="mb-0">{userData?.company_name}</h5>
                        {!isSellerAdmin && <p className="mb-0">Seller ID : {userData?.seller_id}</p>}
                    </div>
                </div>
                <hr />
                <Form layout="vertical" form={form} onFinish={updateUserData}>
                    <Row gutter={16}>
                        <Col span={8}>
                            <Form.Item
                                label="Company Name"
                                name="company_name"
                                style={{ marginBottom: 10 }}
                                getValueFromEvent={(e) =>
                                    (e?.target?.value || "")
                                        .replace(/[@#$%^&*!~+=<>?/\\{}()[\]|`"';:_]/g, "")
                                        .replace(/^\s+/, "")
                                        .replace(/\s{2,}/g, " ")
                                        .slice(0, 100)
                                }
                                rules={[
                                    { required: true, message: "Company Name is required!" },
                                    { max: 100, message: "Company name cannot exceed 100 characters!" },
                                    {
                                        validator: (_, value) => {
                                            if (!value) return Promise.resolve();
                                            if (/[@#$%^&*!~+=<>?/\\{}()[\]|`"';:_]/.test(value)) {
                                                return Promise.reject(new Error("Special characters (@, #, $, etc.) are not allowed!"));
                                            }
                                            if (/\s{2,}/.test(value)) {
                                                return Promise.reject(new Error("Multiple consecutive spaces are not allowed!"));
                                            }
                                            return Promise.resolve();
                                        }
                                    }
                                ]}
                            >
                                <Input
                                    className="p-2"
                                    maxLength={100}
                                    placeholder="Company Name"
                                    onKeyDown={(e) => {
                                        const currentVal = form.getFieldValue("company_name") || "";
                                        if (e.key === " " && (!currentVal || currentVal.endsWith(" "))) {
                                            e.preventDefault();
                                        }
                                        if (/[@#$%^&*!~+=<>?/\\{}()[\]|`"';:_]/.test(e.key)) {
                                            e.preventDefault();
                                        }
                                    }}
                                />
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item
                                label="Contact Number"
                                name="contact_no"
                                style={{ marginBottom: 10 }}
                                getValueFromEvent={(e) => (e?.target?.value || "").replace(/\D/g, "")}
                                rules={[
                                    { required: true, message: "Contact Number is required!" },
                                    {
                                        validator: (_, value) => {
                                            if (!value) return Promise.resolve();
                                            const val = String(value).trim();
                                            if (val.startsWith("0")) return Promise.reject(new Error("Contact number cannot start with 0!"));
                                            if (!/^[6-9][0-9]{9}$/.test(val)) {
                                                return Promise.reject(new Error("Please enter a valid 10-digit number starting with 6-9!"));
                                            }
                                            return Promise.resolve();
                                        }
                                    }
                                ]}
                            >
                                <Input
                                    className="p-2"
                                    maxLength={10}
                                    readOnly
                                    placeholder="10-digit contact number"
                                    onKeyDown={(e) => { if (e.key === " ") e.preventDefault(); }}
                                />
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item
                                label="User Name"
                                name="user_name"
                                style={{ marginBottom: 10 }}
                                getValueFromEvent={(e) => (e?.target?.value || "").replace(/[^a-zA-Z0-9]/g, "")}
                                rules={[
                                    { required: true, message: "User Name is required!" },
                                    { pattern: /^[a-zA-Z0-9]+$/, message: "Special characters and spaces are not allowed!" },
                                    { max: 50, message: "User name cannot exceed 50 characters!" }
                                ]}
                            >
                                <Input
                                    className="p-2"
                                    maxLength={50}
                                    placeholder="User Name"
                                    onKeyDown={(e) => {
                                        if (e.key === " " || (!/^[a-zA-Z0-9]$/.test(e.key) && !["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"].includes(e.key))) {
                                            e.preventDefault();
                                        }
                                    }}
                                />
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item
                                label="User Email"
                                name="user_email"
                                style={{ marginBottom: 10 }}
                                getValueFromEvent={(e) => (e?.target?.value || "").replace(/\s+/g, "")}
                                rules={[
                                    { required: true, message: "User Email is required!" },
                                    { type: "email", message: "Please enter a valid email address!" },
                                    { max: 90, message: "Email cannot exceed 90 characters!" }
                                ]}
                            >
                                <Input
                                    className="p-2"
                                    disabled={isSellerAdmin}
                                    readOnly={isSellerAdmin}
                                    style={isSellerAdmin ? { backgroundColor: "#F8FAFC", cursor: "not-allowed", color: "#64748B" } : {}}
                                    placeholder="email@example.com"
                                    onKeyDown={(e) => { if (e.key === " ") e.preventDefault(); }}
                                />
                            </Form.Item>
                        </Col>

                        {/* <Col span={8}>
                            <Form.Item label="Features Enabled" name="features_enabled">
                                <Input
                                    disabled
                                    className="p-2"
                                    value={form.getFieldValue("features_enabled") || "N/A"}
                                />
                            </Form.Item>
                        </Col> */}

                        {/* <Col span={8}>
                            <Form.Item label="Display Email" name="user_display_email" style={{ marginBottom: 10 }}>
                                <Input className="p-2" />
                            </Form.Item>
                        </Col> */}

                        <Col span={8}>
                            <Form.Item
                                label="User Mobile"
                                name="user_mobile"
                                style={{ marginBottom: 10 }}
                                getValueFromEvent={(e) => (e?.target?.value || "").replace(/\D/g, "")}
                                rules={[
                                    { required: true, message: "User Mobile is required!" },
                                    {
                                        validator: (_, value) => {
                                            if (!value) return Promise.resolve();
                                            const val = String(value).trim();
                                            if (val.startsWith("0")) return Promise.reject(new Error("Mobile number cannot start with 0!"));
                                            if (!/^[6-9][0-9]{9}$/.test(val)) {
                                                return Promise.reject(new Error("Please enter a valid 10-digit mobile number starting with 6-9!"));
                                            }
                                            return Promise.resolve();
                                        }
                                    }
                                ]}
                            >
                                <Input
                                    className="p-2"
                                    readOnly
                                    maxLength={10}
                                    placeholder="10-digit mobile number"
                                    onKeyDown={(e) => { if (e.key === " ") e.preventDefault(); }}
                                />
                            </Form.Item>
                        </Col>

                        {/* <Col span={8}>
                            <Form.Item
                                label="PAN Number"
                                name="pan_no"
                                style={{ marginBottom: 10 }}
                                getValueFromEvent={(e) => (e?.target?.value || "").replace(/\s+/g, "").toUpperCase()}
                                rules={[
                                    {
                                        validator: (_, value) => {
                                            if (!value) return Promise.resolve();
                                            const val = String(value).trim();
                                            if (val.length > 10) return Promise.reject(new Error("PAN Number cannot exceed 10 characters!"));
                                            if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(val)) {
                                                return Promise.reject(new Error("Please enter a valid 10-character PAN (e.g. ABCDE1234F)!"));
                                            }
                                            return Promise.resolve();
                                        }
                                    }
                                ]}
                            >
                                <Input
                                    className="p-2"
                                    maxLength={10}
                                    placeholder="10-digit PAN (e.g. ABCDE1234F)"
                                    style={{ textTransform: "uppercase" }}
                                    onKeyDown={(e) => { if (e.key === " ") e.preventDefault(); }}
                                />
                            </Form.Item>
                        </Col> */}

                        <Col span={8}>
                            <Form.Item
                                label="GST Number"
                                name="gst_no"
                                style={{ marginBottom: 10 }}
                                getValueFromEvent={(e) => (e?.target?.value || "").replace(/\s+/g, "").toUpperCase()}
                                rules={[
                                    { required: true, message: "GST Number is required!" },
                                    {
                                        validator: (_, value) => {
                                            if (!value) return Promise.resolve();
                                            const val = String(value).trim();
                                            if (val.length > 15) return Promise.reject(new Error("GST Number cannot exceed 15 characters!"));
                                            if (!/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{3}$/.test(val)) {
                                                return Promise.reject(new Error("Please enter a valid 15-character GST Number!"));
                                            }
                                            return Promise.resolve();
                                        }
                                    }
                                ]}
                            >
                                <Input
                                    className="p-2"
                                    maxLength={15}
                                    readOnly
                                    placeholder="15-digit GST (e.g. 07AAAAA0000A1Z5)"
                                    style={{ textTransform: "uppercase" }}
                                    onKeyDown={(e) => { if (e.key === " ") e.preventDefault(); }}
                                />
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item
                                label="Short Description"
                                name="short_description"
                                style={{ marginBottom: 10 }}
                                rules={[
                                    { required: true, message: "Short Description is required!" },
                                    { max: 250, message: "Short description cannot exceed 250 characters!" }
                                ]}
                            >
                                <Input className="p-2" maxLength={250} placeholder="Brief summary" />
                            </Form.Item>
                        </Col>

                        {!isSellerAdmin && (
                            <>
                                <Col span={8}>
                                    <Form.Item
                                        label="Seller Type"
                                        name="seller_type"
                                        style={{ marginBottom: 10 }}
                                        rules={[{ required: true, message: "Seller Type is required!" }]}
                                    >
                                        <Select placeholder="Select Seller Type">
                                            <Select.Option value="wholesaler">Wholesaler</Select.Option>
                                            <Select.Option value="distributor">Distributor</Select.Option>
                                            <Select.Option value="manufacturer">Manufacturer</Select.Option>
                                        </Select>
                                    </Form.Item>
                                </Col>

                                <Col span={8}>
                                    <Form.Item
                                        label="Min Order Value (₹)"
                                        name="min_order_value"
                                        style={{ marginBottom: 10 }}
                                        rules={[
                                            { required: true, message: "Min Order Value is required!" },
                                            { pattern: /^\d+(\.\d{1,2})?$/, message: "Please enter a valid number (e.g. 500 or 500.50)" }
                                        ]}
                                        getValueFromEvent={(e) => {
                                            let val = e.target.value.replace(/[^0-9.]/g, "");
                                            const parts = val.split(".");
                                            if (parts.length > 2) {
                                                val = parts[0] + "." + parts.slice(1).join("");
                                            }
                                            if (parts[1] && parts[1].length > 2) {
                                                val = parts[0] + "." + parts[1].slice(0, 2);
                                            }
                                            return val;
                                        }}
                                    >
                                        <Input className="p-2" placeholder="500.00" />
                                    </Form.Item>
                                </Col>
                            </>
                        )}

                        {/* <Col span={8}>
                            <Form.Item
                                label="Seller Source"
                                name="seller_source"
                                style={{ marginBottom: 10 }}
                            >
                                <Input className="p-2" maxLength={50} placeholder="Source" />
                            </Form.Item>
                        </Col> */}

                        <Col span={8}>
                            <Form.Item label="Status" name="status" style={{ marginBottom: 10 }}>
                                <Input className="p-2" placeholder="Status" disabled style={{ backgroundColor: "#F8FAFC" }} />
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item label="Approve Status" name="approve_status_label" style={{ marginBottom: 10 }}>
                                <Input className="p-2" placeholder="Approve Status" disabled style={{ backgroundColor: "#F8FAFC" }} />
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item
                                label="Company Logo"
                                name="logo"
                                style={{ marginBottom: 10 }}
                                rules={[{ required: true, message: "Company Logo is required!" }]}
                            >
                                <div className="d-flex align-items-center" style={{ gap: 10 }}>
                                    <Upload
                                        name="file"
                                        accept="image/*,.png,.jpg,.jpeg,.webp,.img"
                                        customRequest={(options) => handleCustomUpload(options, "logo")}
                                        showUploadList={false}
                                    >
                                        <Button icon={<UploadOutlined />}>Upload Logo</Button>
                                    </Upload>
                                    {form.getFieldValue("logo") && (
                                        <a href={form.getFieldValue("logo")} target="_blank" rel="noreferrer" style={{ fontSize: "12px" }}>
                                            View Logo
                                        </a>
                                    )}
                                </div>
                            </Form.Item>
                        </Col>

                        {/* <Col span={8}>
                            <Form.Item label="PAN Image" name="pan_image" style={{ marginBottom: 10 }}>
                                <div className="d-flex align-items-center" style={{ gap: 10 }}>
                                    <Upload
                                        name="file"
                                        accept="image/*,.png,.jpg,.jpeg,.webp,.img"
                                        customRequest={(options) => handleCustomUpload(options, "pan_image")}
                                        showUploadList={false}
                                    >
                                        <Button icon={<UploadOutlined />}>Upload PAN</Button>
                                    </Upload>
                                    {form.getFieldValue("pan_image") && (
                                        <a href={form.getFieldValue("pan_image")} target="_blank" rel="noreferrer" style={{ fontSize: "12px" }}>
                                            View PAN
                                        </a>
                                    )}
                                </div>
                            </Form.Item>
                        </Col> */}

                        <Col span={8}>
                            <Form.Item
                                label="GST Image"
                                name="gst_image"
                                style={{ marginBottom: 10 }}
                            >
                                <div className="d-flex align-items-center" style={{ gap: 10 }}>
                                    <Upload
                                        name="file"
                                        accept="image/*,.png,.jpg,.jpeg,.webp,.img"
                                        customRequest={(options) => handleCustomUpload(options, "gst_image")}
                                        showUploadList={false}
                                    >
                                        <Button icon={<UploadOutlined />}>Upload GST</Button>
                                    </Upload>
                                    {form.getFieldValue("gst_image") && (
                                        <a href={form.getFieldValue("gst_image")} target="_blank" rel="noreferrer" style={{ fontSize: "12px" }}>
                                            View GST
                                        </a>
                                    )}
                                </div>
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="Description"
                                name="description"
                                rules={[
                                    { required: true, message: "Description is required!" },
                                    { max: 1000, message: "Description cannot exceed 1000 characters!" }
                                ]}
                            >
                                <Input.TextArea rows={4} maxLength={1000} showCount placeholder="Detailed description..." />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Button type="primary" htmlType="submit" style={{ borderRadius: "100px" }}>
                        {isLoading ? "Loading..." : " Update "}
                    </Button>
                </Form>
            </Card>
        </ThemeMaker>
    );
};

export default UserDetails;
